import LoginForm from './loginForm.js';

export default LoginForm;